module.exports = __webpack_public_path__ + "img/Dantam Bridal 22b.e7226470.jpg";